import { Skeleton, TableCell, TableHead, TableRow } from '@mui/material'
import { DeviceMeteringsDataRowHeight } from 'whats_inside/src/pages/deviceData/util'

export const MeteringDataTableHeadSkeleton = () => {
  return (
    <TableHead>
      <TableRow style={{ height: DeviceMeteringsDataRowHeight }}>
        <TableCell width={90}>
          <Skeleton />
        </TableCell>
        <TableCell align='right'>
          <Skeleton />
        </TableCell>
        <TableCell align='right'>
          <Skeleton />
        </TableCell>
        <TableCell align='right'>
          <Skeleton />
        </TableCell>
      </TableRow>
    </TableHead>
  )
}
